export default __webpack_public_path__ + "static/online-shop-046ff8707d2c1a3ecd456675deb85808.png";